export const FaqCities = ["warszawa", "krakow", "wroclaw", "gdansk", "poznan", "lodz", "katowice"];
export const FaqCities = ["warszawa", "krakow", "wroclaw", "gdansk", "poznan", "lodz", "katowice"];
